import { fetchSearchData, fetchCenterAllConditions } from './api';
// import { mockCenterConditionData } from '@/modules/md-search-bar/mock.js';
import * as TYPES from './_store/types';
import { usePageStore } from '@/store'
import util from '../../common/util';
async function initSearchGroup() {}
async function searchBar(store, searchConfig) {
    const {
        propertyConfigs = [],
        searchBarMappingStrategy
    } = searchConfig;
    const query = this.pageLocation.query;
    if (query.key) {
        let keys = query.key.split(':');
        store[TYPES.SET_KEYWORD](keys.slice(1).join(':') || '');
        store[TYPES.SET_KEYWORD_TYPE](keys[0] || 'none');
    }
    store[TYPES.SET_PROPERTY_CONFIGS](propertyConfigs);
    store[TYPES.SET_IS_EXACT_SEARCH](
        searchBarMappingStrategy === '0'
    );
    propertyConfigs.forEach(config => {
        try {
            if (config.values && !config.args) {
                config.args = JSON.parse(config.values);
            }
        } catch (e) {
            console.error(e);
        }
    });
}
async function processData(store) {
    const { confArr, locationConf } = filter.call(this, store);
    processPropertyConf.call(this, store, confArr);
    if (locationConf) {
        processLocationConf.call(this, store, locationConf);
    }
}
function processLocationConf(store, conf) {
    store[TYPES.SET_IS_EXACT_SEARCH](!conf.freeInput);
    store[TYPES.SET_SEARCH_CHARTS](conf.typeLabels || {});
    store[TYPES.SET_LOCATION_SUGGESTION_URL](
        conf.suggestionUrl || ''
    );
}
function formatOptions(conf, type) {
    return (
        ((conf = conf.mask) &&
            (conf = conf.opt) &&
            (conf = conf[type])
                .split('\n')
                .map(o => ({ label: o, value: o }))) ||
        []
    );
}
function processPropertyConf(store, confArr = []) {
    confArr.forEach(async conf => {
        const mask = conf.mask || {};
        if (conf.inputType === 'inputBox') {
            const min = formatOptions(conf, 'min');
            const max = formatOptions(conf, 'max');

            conf.args = {
                options: [min, max],
                minTitle: mask.minTitle.replace('#global_name#', conf.label),
                maxTitle: mask.maxTitle.replace('#global_name#', conf.label),
                minLabel: mask.minTag,
                maxLabel: mask.maxTag
            };
        } else if (
            conf.inputType === 'multiSelect' ||
            conf.inputType === 'singleSelect'
        ) {
            conf.options = [];
            conf.args = [
                { label: this.$t('md-hero:md-hero.any'), value: '' }
            ];
        }
    });
    store[TYPES.SET_PROPERTY_CONFIGS](confArr);
    // this.propertyConfigs = confArr;
    // return conf;
}
function filter(store) {
    let searchData = store.searchData;
    let confArr = [];
    let locationConf = null;
    // searchCenter Fix these five
    const configFilter = [
        'propertyType',
        'price',
        'baths',
        'beds',
        'purchaseType'
    ];
    // searchData  from interface  /api-site/search/search-data
    for (let search of searchData) {
        for (let o of search.conditions) {
            if (Array.isArray(configFilter) && configFilter.includes(o.name)) {
                confArr.push(o);
            }
            if (o.name.toLowerCase() === 'location') {
                locationConf = o;
            }
        }
    }
    // store[TYPES.SET_SHOW_LOCATION](!!locationConf);
    return { confArr, locationConf };
}
async function searchBarCenter(store, searchConfig) {
    store[TYPES.SET_SEARCH_DATA](searchConfig.configs);
    store[TYPES.SET_LOCATION_PLACEHOLDER](
        searchConfig.locationPlaceholder
            .map(({ name, nameText }) => nameText || name)
            .filter(Boolean)
            .join(', ')
    );
    await processData.call(this, store);
    // TODO location
}
export async function initSearchBar(store, globalData) {
    const siteId = globalData.siteId;
    const listingType = store.listingType;
    const searchCenter = globalData.searchCenter;
    let searchConfig;
    try {
        if (searchCenter) {
            searchConfig = await fetchCenterAllConditions.call(this, {
                siteId,
                isSold: listingType === 'sold-listing'
            });
        } else {
            searchConfig = await fetchSearchData.call(this, { siteId });
        }
        if (searchCenter) {
            await searchBarCenter.call(this, store, searchConfig);
        } else {
            await searchBar.call(this, store, searchConfig);
        }
    } catch (error) {
        console.log(error);
    }
}

export function asyncData(store) {
    let { page: globalData } = usePageStore(this.$pinia);
    if (util.inCms) {
        return initSearchBar.call(this, store, globalData);
    } else if (this.searchStyle === 'search-bar') {
        return initSearchBar.call(this, store, globalData);
    } else if (this.searchStyle === 'search-group') {
        return initSearchBar.call(this, store, globalData);
    }
}
